import { NgModule } from 'ng-metadata/core';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuSubheaderComponent } from './menu-subheader/menu-subheader.component';
import { MenuTriggerButtonComponent } from './menu-trigger/menu-trigger-button.component';
import { MenuTriggerIconButtonComponent}  from './menu-trigger/menu-trigger-icon-button.component';
import './menu.scss';

/**
 * @ngdoc module
 * @name mw.components.menu
 * @description
 *
 * Menu
 */
@NgModule({
    imports: ['ngMaterial', 'pascalprecht.translate'],
    declarations: [ MenuItemComponent, MenuSubheaderComponent, MenuTriggerButtonComponent, MenuTriggerIconButtonComponent ]
})
export class MenuModule {}



// WEBPACK FOOTER //
// ./src/lib/components/menu/menu.module.ts